import { ApiUrl } from '@common/enums';
import { WaterfallLabor } from '@common/models';
import { easyEstimatorApi } from '@ee-api/easyEstimatorService';
import { CommonProductQueryParams } from '@ee-api/queryParams';

export const waterfallLaborApi = easyEstimatorApi.injectEndpoints({
    endpoints: (builder) => ({
        getWaterfallLaborFee: builder.query<WaterfallLabor, CommonProductQueryParams>({
            query: ({ params }) => ({
                url: ApiUrl.WATERFALL_LABOR,
                method: 'GET',
                params,
            }),
        }),
    }),
});

export const { useGetWaterfallLaborFeeQuery } = waterfallLaborApi;
